define('plugin/group-booking/view/GroupBookingTimelineView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#group_booking_timeline_view',
        _bookingModel: null,
        _maxCount: 1,
        _minCount: 1,
        _default: 1,

        ui: {
            count: ':input'
        },
        events: {
            'change @ui.count': 'onChangeCount'
        },

        initialize: function () {
            this._bookingModel = this.getOption('bookingModel');
            this._maxCount = this.getOption('count');
            this._minCount = this.getOption('minCount');
            this._default = this.getOption('default');

            if(this.getOption('default') && this.getOption('default')>0) {
                this._default = this.getOption('default');
            }

            this.onChangeCount = _.throttle(this.onChangeCount, 500);
        },

        onChangeCount: function () {
            var count = parseInt(this.ui.count.val());
            if (!_.isNumber(count) || count < 1) {
                count = this._default;
            }
            this._bookingModel.set('count', count);
            this.triggerMethod('count_changed', count);
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.max_count = this._maxCount;
            result.min_count = this._minCount;
            result.default = this._default;
            result.count = this._bookingModel.get('count');

            return result;
        }

    });

});
